export const root = '/subscription';

export const invoices = `${root}/invoices`;
export const plans = `${root}/plans`;
export const planDetails = `${root}/plans/:providerPlanId`;
